import {palette, updatePrimaryPalette, updateSurfacePalette} from '@primeng/themes';
import Aura from '@primeng/themes/aura';
import {PrimeNGConfigType} from 'primeng/config';

// const Noir = definePreset(Aura, {
//   semantic: {
//     primary: {
//       50: '{zinc.50}',
//       100: '{zinc.100}',
//       200: '{zinc.200}',
//       300: '{zinc.300}',
//       400: '{zinc.400}',
//       500: '{zinc.500}',
//       600: '{zinc.600}',
//       700: '{zinc.700}',
//       800: '{zinc.800}',
//       900: '{zinc.900}',
//       950: '{zinc.950}'
//     },
//     colorScheme: {
//       light: {
//         primary: {
//           color: '{zinc.950}',
//           inverseColor: '#ffffff',
//           hoverColor: '{zinc.900}',
//           activeColor: '{zinc.800}'
//         },
//         highlight: {
//           background: '{zinc.950}',
//           focusBackground: '{zinc.700}',
//           color: '#ffffff',
//           focusColor: '#ffffff'
//         }
//       },
//       dark: {
//         primary: {
//           color: '{zinc.50}',
//           inverseColor: '{zinc.950}',
//           hoverColor: '{zinc.100}',
//           activeColor: '{zinc.200}'
//         },
//         highlight: {
//           background: 'rgba(250, 250, 250, .16)',
//           focusBackground: 'rgba(250, 250, 250, .24)',
//           color: 'rgba(255,255,255,.87)',
//           focusColor: 'rgba(255,255,255,.87)'
//         }
//       }
//     }
//   }
// });

export const zenTheme: PrimeNGConfigType = {
  ripple: true,
  theme: {
    preset: Aura,
    options: {
      darkModeSelector: 'none'
    }
  }
};

export function onThemeChange() {
  setTimeout(() => {
    changePrimaryColor();
    changeSurfaces();
  }, 2 * 1000);
  // changeSurfaces();
}

function changePrimaryColor() {
  const style = window.getComputedStyle(document.body).getPropertyValue('--primary-color');
  console.log(style);
  if (!style) {
    return;
  }
  const val = palette(style);
  updatePrimaryPalette(val);
}


function changeSurfaces() {
  const color = window.getComputedStyle(document.body).getPropertyValue('--surface-600');
  if (!color) {
    return;
  }
  const val = palette(color);
  updateSurfacePalette(val);
}

